<template>
	<div class="war-1">
		<div class="war-2">
			<div class="war-3">
				<el-date-picker v-model="value1" type="date" placeholder="选择日期" @change="changeTime">
				</el-date-picker>
			</div>
			<div class="war-4">
				<div>{{value1}}</div>
				<div>至</div>
				<div>{{value7}}</div>
			</div>
		</div>

		<div class="info-1">
			<div></div>
			<div>
				<div>{{week1}}</div>
				<div>{{value1}}</div>
			</div>
			<div>
				<div>{{week2}}</div>
				<div>{{value2}}</div>
			</div>
			<div>
				<div>{{week3}}</div>
				<div>{{value3}}</div>
			</div>
			<div>
				<div>{{week4}}</div>
				<div>{{value4}}</div>
			</div>
			<div>
				<div>{{week5}}</div>
				<div>{{value5}}</div>
			</div>
			<div>
				<div>{{week6}}</div>
				<div>{{value6}}</div>
			</div>
			<div>
				<div>{{week7}}</div>
				<div>{{value7}}</div>
			</div>
		</div>
		<div class="info-2" v-for="(item,index) in timeList" :key="index">
			<div>{{item.time}}</div>
			<div>

			</div>
			<div>

			</div>
			<div>

			</div>
			<div>

			</div>
			<div>

			</div>
			<div>

			</div>
			<div>

			</div>
		</div>
	</div>
</template>

<script>
	import moment from "moment"
	export default {
		data() {
			return {
				value1: '',
				value2: '',
				value3: '',
				value4: '',
				value5: '',
				value6: '',
				value7: '',
				week1: '',
				week2: '',
				week3: '',
				week4: '',
				week5: '',
				week6: '',
				week7: '',
				timeList:[
					{
						id:'1',
						time:'09:00'
					},
					{
						id:'2',
						time:'10:00'
					},
					{
						id:'3',
						time:'11:00'
					}
				]
			}
		},
		created() {
			this.value1 = moment().format('YYYY-MM-DD');
			this.week1 = this.getWeek(this.value1)
			this.value2 = moment(this.value1).add(1, 'days').format('YYYY-MM-DD')
			this.week2 = this.getWeek(this.value2)
			this.value3 = moment(this.value1).add(2, 'days').format('YYYY-MM-DD')
			this.week3 = this.getWeek(this.value3)
			this.value4 = moment(this.value1).add(3, 'days').format('YYYY-MM-DD')
			this.week4 = this.getWeek(this.value4)
			this.value5 = moment(this.value1).add(4, 'days').format('YYYY-MM-DD')
			this.week5 = this.getWeek(this.value5)
			this.value6 = moment(this.value1).add(5, 'days').format('YYYY-MM-DD')
			this.week6 = this.getWeek(this.value6)
			this.value7 = moment(this.value1).add(6, 'days').format('YYYY-MM-DD')
			this.week7 = this.getWeek(this.value7)
		},
		methods: {
			changeTime(e) {
				this.value1 = moment(e).format('YYYY-MM-DD');
				this.week1 = this.getWeek(this.value1)
				this.value2 = moment(this.value1).add(1, 'days').format('YYYY-MM-DD')
				this.week2 = this.getWeek(this.value2)
				this.value3 = moment(this.value1).add(2, 'days').format('YYYY-MM-DD')
				this.week3 = this.getWeek(this.value3)
				this.value4 = moment(this.value1).add(3, 'days').format('YYYY-MM-DD')
				this.week4 = this.getWeek(this.value4)
				this.value5 = moment(this.value1).add(4, 'days').format('YYYY-MM-DD')
				this.week5 = this.getWeek(this.value5)
				this.value6 = moment(this.value1).add(5, 'days').format('YYYY-MM-DD')
				this.week6 = this.getWeek(this.value6)
				this.value7 = moment(this.value1).add(6, 'days').format('YYYY-MM-DD')
				this.week7 = this.getWeek(this.value7)
			},
			getWeek(date) {
				let week = moment(date).day()
				switch (week) {
					case 1:
						return '周一'
					case 2:
						return '周二'
					case 3:
						return '周三'
					case 4:
						return '周四'
					case 5:
						return '周五'
					case 6:
						return '周六'
					case 0:
						return '周日'
				}
			},
		}
	}
</script>

<style lang="less" scoped>
	.war-1 {
		width: 98%;
		margin-left: 2%;
	}

	.war-2 {
		width: 100%;
		height: 40px;
		line-height: 40px;
		background-color: #CCCCCC;
		border: 1px solid #AAAAAA;
		display: flex;
		align-items: center;
	}

	.war-3 {
		width: 150px;

		/deep/ .el-input__inner {
			background-color: transparent;
			border: none;
		}
	}

	.war-4 {
		width: 60%;
		display: flex;
		justify-content: center;
		font-weight: bold;
	}

	.war-4>div:nth-child(2) {
		margin: 0 10px;
	}

	.info-1 {
		width: 100%;
		display: flex;
		height: 40px;
		background-color: #F1F1F1;
		
		border-bottom: 1px solid #AAAAAA;
	}

	.info-1>div {
		width: 12.5%;
		text-align: center;
	}
	.info-2{
		width: 100%;
		display: flex;
		height: 100px;
		line-height: 100px;
	}
	.info-2>div{
		width: 12.5%;
		text-align: center;
		border-right: 1px solid #AAAAAA;
		border-bottom: 1px solid #AAAAAA;
	}
</style>
